import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Select, TextInput } from '@mantine/core';
import AppStack from '../../common/AppStack';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import { triggerNotification } from '../../../helpers/notification';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppImage from '../../common/AppImage';

const EditMediaModal = ({
  isOpen,
  onClose,
  fkEcomVendor,
  fkEcomStore,
  media,
  onSuccess
}) => {
  const [formState, setFormState] = useState({
    alt: '',
    contentType: '',
    loading: false
  });
  const { updateVendorMedia } = useContext(VendorContext);
  const { updateStoreMedia } = useContext(StoreContext);

  useEffect(() => {
    if (isOpen) {
      setFormState({
        alt: media ? media.alt : '',
        contentType: media ? media.contentType : '',
        loading: false
      });
    }
  }, [isOpen]);

  const onSuccessCallback = () => {
    triggerNotification(`Media updated.`, 'success');
    onClose();
    if (onSuccess) {
      onSuccess();
    }
  };

  const onErrorCallback = (e) => {
    setFormState({ ...formState, loading: false });
    triggerNotification(e);
  };

  return (
    <ResponsiveModal
      formSectionProps={{
        onCancel: onClose,
        isLoading: formState.loading,
        onSubmit: () => {
          setFormState({ ...formState, loading: true });
          if (fkEcomVendor) {
            updateVendorMedia(
              fkEcomVendor,
              [
                {
                  pkEcomVendorMedia: media.pkEcomVendorMedia,
                  alt: formState.alt,
                  contentType: formState.contentType
                }
              ],
              onSuccessCallback,
              onErrorCallback
            );
          }
          else {
            updateStoreMedia(
              fkEcomStore,
              [
                {
                  pkEcomStoreMedia: media.pkEcomStoreMedia,
                  alt: formState.alt,
                  contentType: formState.contentType
                }
              ],
              onSuccessCallback,
              onErrorCallback
            );
          }
        },
        submitTitle: `Save changes`
      }}
      isOpen={isOpen && !!media}
      onClose={onClose}
      size={500}
      title="Update media"
    >
      {media && (
        <AppStack style={{ gap: 8 }}>
          <AppStack style={{ alignItems: 'center', height: 200 }}>
            <AppImage alt={formState.alt} src={media.src} />
          </AppStack>

          <TextInput
            disabled={formState.loading}
            label="File name"
            onChange={(e) =>
              setFormState({ ...formState, alt: e.currentTarget.value })
            }
            placeholder="store_logo.png"
            required
            value={formState.alt}
          />

          <Select
            disabled
            label="Content type"
            onChange={(e) =>
              setFormState({ ...formState, contentType: e.currentTarget.value })
            }
            placeholder="image/png"
            value={formState.contentType}
          />
        </AppStack>
      )}
    </ResponsiveModal>
  );
};

EditMediaModal.propTypes = {
  fkEcomStore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fkEcomVendor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isOpen: PropTypes.bool,
  media: PropTypes.object,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
};

export default EditMediaModal;
